<button class="pl-2" mat-menu-item (click)="onClick()" [disabled]="disabled">
  <mat-icon class="mr-1" *ngIf="icon">{{ icon }}</mat-icon>
  <bdg-label [type]="labelType">{{ label }} </bdg-label>
</button>
